import { authService } from '../services/supabase/auth';
import { profilesService } from '../services/supabase/profiles';
import { routinesService } from '../services/supabase/routines';
import { sophieProfileData, valerieProfileData } from '../data/mockData';

// Helper to convert legacy routine tasks to new task structure
interface ProfileSeedData {
    displayName: string;
    tasks: any[];
}

async function createProfileWithTasks(profileData: ProfileSeedData) {
    
    // 1. Create Profile
    const profile = await profilesService.createProfile(profileData.displayName);
    
    // 2. Create a default routine with tasks (tasks must belong to a routine)
    if (profileData.tasks.length > 0) {
      const tasks = profileData.tasks.map((task, index) => ({
        label: task.label,
        icon: task.icon || '',
        color: task.color || '',
        start_time: task.start,
        end_time: task.end,
        order_index: index,
      }));

      const startTime = tasks[0]?.start_time || '08:00';
      const endTime = tasks[tasks.length - 1]?.end_time || '20:00';

      await routinesService.createRoutine({
        childIds: [profile.id],
        name: `${profileData.displayName}'s Daily Routine`,
        type: 'daily',
        startTime,
        endTime,
        daysOfWeek: [1, 2, 3, 4, 5],
        startDate: new Date().toISOString().split('T')[0],
        endDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        tasks
      });
    }
}

export async function seedAllMockData() {
  try {
    
    const response = await authService.getUser();
    const user = response.user;
    if (!user) throw new Error('User not authenticated');

    // Check if profiles already exist
    const existingProfiles = await profilesService.getProfiles();
    if (existingProfiles && existingProfiles.length > 0) {
        return true;
    }

    // Create profiles from mock data
    await createProfileWithTasks(sophieProfileData);
    await createProfileWithTasks(valerieProfileData);

    // Update settings to show these profiles?
    // Not strictly necessary as the app defaults to showing all if none selected,
    // or we can let the user configure it.
    
    return true;
  } catch (error) {
    console.error('Error seeding data:', error);
    return false;
  }
}
